import {
  ADD_INTRESTED,
  ADD_INTRESTED_FAILURE,
  ADD_INTRESTED_SUCCESS,
  EDIT_INTRESTED,
  EDIT_INTRESTED_FAILURE,
  EDIT_INTRESTED_SUCCESS,
} from '../Actiontype';

const initialState = {
  AddorEdituserSuccess: false,
  AddorEdituserSuccessMessage: '',
  AddorEdituserFailure: false,
  AddorEdituserFailureMessage: '',
  UserDetails: null,
};
export default function InterstedReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_INTRESTED:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case ADD_INTRESTED_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case ADD_INTRESTED_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    case EDIT_INTRESTED:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case EDIT_INTRESTED_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case EDIT_INTRESTED_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    default:
      return {
        ...state,
      };
  }
}
